'use strict'

module.exports = bail

function bail(err) {
  if (err) {
    throw err
  }
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/bail/index.js
// module id = 308
// module chunks = 0 1 9 10